export default [
  {
    title: 'Catálogos',
    icon: 'FolderIcon',
    children: [
      {
        title: 'Mallas',
        route: 'catalogos-mallas',
        icon: 'GridIcon',
      },
      {
        title: 'Centros de Trabajo',
        route: 'catalogos-centro-trabajo',
        icon: 'LayersIcon',
      },
      {
        title: 'Empleados',
        route: 'catalogos-empleados',
        icon: 'UsersIcon',
        action: 'read',
        resource: 'Checador',
      },
      {
        title: 'Conceptos de Gastos',
        route: 'catalogos-gastos',
        icon: 'TagIcon',
      },
    ],
  },
];
